import React, { useEffect, useState } from 'react';
import { Tooltip } from '@chakra-ui/react';

const KEY = 'dtcTheme';
const ORDER = ['system', 'light', 'dark'];

function readTheme() {
  try {
    const v = localStorage.getItem(KEY);
    return ORDER.includes(v) ? v : 'system';
  } catch (e) {
    return 'system';
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === 'light' || theme === 'dark') root.setAttribute('data-cv-theme', theme);
  else root.removeAttribute('data-cv-theme');
}

const PATHS = {
  system: ['M3 4h18v12H3z', 'M8 20h8', 'M12 16v4'],
  light: ['M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z', 'M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4'],
  dark: ['M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z'],
};

/** Header button cycling the colour theme: system -> light -> dark. Stored per browser. */
export default function ThemeToggle({ translate = (s) => s }) {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(KEY, theme); } catch (e) { /* private mode */ }
  }, [theme]);

  const label = `${translate('Theme')}: ${translate(theme === 'system' ? 'System' : theme === 'light' ? 'Light' : 'Dark')}`;
  return (
    <Tooltip label={label} openDelay={300}>
      <button
        type="button"
        className="theme-toggle"
        aria-label={label}
        onClick={() => setTheme((t) => ORDER[(ORDER.indexOf(t) + 1) % ORDER.length])}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          {PATHS[theme].map((d) => <path key={d} d={d} />)}
        </svg>
      </button>
    </Tooltip>
  );
}
